import { createAction } from "@reduxjs/toolkit";
import { TalesSponsor } from "../../../utils/types/TalesSponsor";

export const setSponsorData = createAction<TalesSponsor[]>("sponsor/setData");
